import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';

export const useCurrentBreakpoint = () => {
  const theme = useTheme();

  // Call all hooks at the top level
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));
  const isXxl = useMediaQuery(theme.breakpoints.only('xxl'));
  // xxxl is anything larger than xxl (typically 2200px+)

  // Determine current breakpoint
  const currentBreakpoint = useMemo(() => {
    if (isXs) return 'xs';
    if (isSm) return 'sm';
    if (isMd) return 'md';
    if (isLg) return 'lg';
    if (isXl) return 'xl';
    if (isXxl) return 'xxl';
    return 'xxxl';
  }, [isXs, isSm, isMd, isLg, isXl, isXxl]);

  return currentBreakpoint;
};

export default useCurrentBreakpoint;
